import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import auth from './auth/auth'
import popups from './popups/popups'
import sidebar from './sidebar/sidebar'
import profile from './profile/profile'

import users from './pages/users'
import things from './pages/things'
import journal from './pages/journal'

import roles from './pages/roles/roles'

import projects from './pages/projects/index'

import global from './global/index'

Vue.use(Vuex);

const phoneCodes = require('@/assets/json/phone-codes');

export default new Vuex.Store({
	state: {
    hideSidebar: true,
    delIndex: '',
    phoneCodes: phoneCodes,
    activePhoneCode: { "id": 2, "mask": "(###)###-##-##", "code": "+7", "cc": "RU", "name_en": "Russia", "desc_en": "", "name_ru": "Россия", "desc_ru": "" },
    openProjectsNavigator: true
	},
  getters: {
	  cols: state => {
      let windowWidth = window.innerWidth;
      let rez = '';
      if (windowWidth >= 1780) {
        rez = 4
      } else if (windowWidth > 1280) {
        rez = 3;
      } else {
        rez = 2
      };

      return rez;
    }
  },
	mutations: {
	  TOGGLE_OPEN_PROJECTS_NAVIGATOR(state,data) {
	    state.openProjectsNavigator = data
    },
    SET_SIDEBAR(state,data) {
      state.hideSidebar = data
    },
    SET_DEL_INDEX(state,data) {
      state.delIndex = data
    },
    //phone codes
    SET_ACTIVE_PHONE_CODE(state, data) {
      state.activePhoneCode = data
    },
	},
	actions: {
	  async loadGrid({dispatch, rootState}, obj) {
	    let {data} = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_URL}mapping/get?essence=${obj.name}${obj.id}`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.message;
        let status = e.response.status;
        if (status == 404) {
          throw new Error('404')
        }

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
	    return data
    },
    async createGrid({dispatch, rootState}, obj) {
	    await axios({
        method: 'post',
        url: `${process.env.VUE_APP_URL}mapping/post`,
        data: {
          essence: `${obj.name}${obj.id}`,
          content: JSON.stringify(obj.grid)
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    async updateGrid({dispatch, rootState}, obj) {
	    await axios({
        method: 'post',
        url: `${process.env.VUE_APP_URL}mapping/post`,
        data: {
          essence: `${obj.name}${obj.id}`,
          content: JSON.stringify(obj.grid)
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    }
	},
	modules: {
	  auth,
    popups,
    sidebar,
    profile,
    users,
    things,
    roles,
    projects,
    journal,
    global
	}
})
